import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb07374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background":"#fff"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, "基础信息", -1))
const _hoisted_3 = { class: "centerBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      model: _ctx.formState,
      rules: _ctx.rules,
      ref: "formRef",
      "label-col": { style: { width: '110px' } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form_item, {
            label: "业务编码",
            name: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.code,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.code) = $event)),
                placeholder: "请输入,默认系统自动生成",
                disabled: _ctx.formState.code!=null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "省",
            name: "province"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.province,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.province) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "省编码",
            name: "provinceCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.provinceCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.provinceCode) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "市",
            name: "city"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.city,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.city) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.city==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "市编码",
            name: "cityCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.cityCode,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.cityCode) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.cityCode==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "区",
            name: "area"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.area,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.area) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.area==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "区编码",
            name: "areaCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.areaCode,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.areaCode) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.areaCode==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "镇",
            name: "town"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.town,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.town) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.town==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "镇编码",
            name: "townCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.townCode,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.townCode) = $event)),
                placeholder: "请输入",
                disabled: _ctx.formState.townCode==null&&this.$route.params.code!='new'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "层级",
            name: "level"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.level,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.level) = $event)),
                placeholder: "请输入",
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "备注",
            name: "memo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.memo,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.memo) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_Form_item, {
          "wrapper-col": { span: 14, offset: 10 },
          style: {"background":"#fff","padding":"0px 0px 20px 0px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"padding":"5px 30px"},
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              style: {"margin-left":"40px","padding":"5px 30px"},
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}